// extracted by mini-css-extract-plugin
export default {"iconRightContainer":"common-cta__iconRightContainer___15bvN","block":"common-cta__block___2BKZA","overrideOT":"common-cta__overrideOT___3Jw0R"};